export default (editor, opts = {}) => {
  const pipes = opts.pipes ?? [];
  const forms = opts.forms ?? [];
  const State = opts.State ?? undefined;

  const baseStyle = document.createElement("style");

  baseStyle.innerHTML = `
    @import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;1,100;1,200;1,300;1,400;1,500;1,600;1,700&family=Nunito:wght@200;300;400;500;700&display=swap');

    .cubo-form{
      justify-content: space-between;
      row-gap: 10px;
      font-family: Nunito,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;
    }

    .cubo-form label{
      display: inline-block;
      display: flex;
      width: 100%;
      font-size: 14px;
    }

    .column-6 {
      max-width: 48%;
      flex: 0 0 48%;
    }

    .column-12 {
      max-width: 96%;
      flex: 0 0 96%;
    }

    .column {
      display: flex;
      flex-direction: column;
    }

    .rows {
        display: flex;
    }

    .wrap {
        flex-wrap: wrap;
    }
  `;

  document.getElementsByTagName("head")[0].appendChild(baseStyle);

  const script = function async(props) {
    this.setAttribute("version", "2.0");

    function isDebug() {
      try {
        const url = new URL(window.location.href);
        return Boolean(url.searchParams.get("debug")) || undefined;
      } catch (e) {
        return undefined;
      }
    }

    function logDebug(...args) {
      try {
        if (isDebug()) console.log("[CUBO-FORM]", ...args);
      } catch (e) {}
    }

    function logError(...args) {
      try {
        console.error("[CUBO-FORM]", ...args);
      } catch (e) {}
    }

    function safeRun(label, fn) {
      try {
        return fn();
      } catch (e) {
        logError(label, "falhou:", e);
        return undefined;
      }
    }

    async function safeRunAsync(label, fn) {
      try {
        return await fn();
      } catch (e) {
        logError(label, "falhou:", e);
        return undefined;
      }
    }

    function restoreButton(button, oldText) {
      try {
        if (!button) return;
        button.removeAttribute("disabled");
        if (oldText !== undefined && oldText !== null) button.innerText = oldText;
      } catch (e) {
        logError("restoreButton", e);
      }
    }

    logDebug("BOOT - versão 2.0 inicializando", {
      url: window.location.href,
      userAgent: navigator.userAgent,
      cookieEnabled: navigator.cookieEnabled,
      online: navigator.onLine,
      props,
    });

    function hideFields() {
      const fields = document.querySelectorAll('[data-hidden="true"]');
      fields.forEach((field) => {
        field.style.display = "none";
      });
    }

    function defineCookies() {
      try {
        if (typeof Cookies !== "undefined") {
          logDebug("defineCookies - Cookies já disponível");
          return;
        }
        logDebug("defineCookies - injetando /assets/js/js-cookies.js");
        var cookiesScript = document.createElement("script");
        cookiesScript.src = "/assets/js/js-cookies.js";
        cookiesScript.type = "text/javascript";
        cookiesScript.onload = () =>
          logDebug("defineCookies - js-cookies carregado");
        cookiesScript.onerror = (e) =>
          logError("defineCookies - falha ao carregar js-cookies", e);
        document.getElementsByTagName("head")[0].appendChild(cookiesScript);
      } catch (e) {
        logError("defineCookies - falha:", e);
      }
    }

    function definePristine() {
      try {
        if (typeof Pristine === "undefined") {
          logDebug("definePristine - injetando /assets/js/pristine.js");
          var pristineScript = document.createElement("script");
          pristineScript.src = "/assets/js/pristine.js";
          pristineScript.type = "text/javascript";
          pristineScript.onload = () =>
            logDebug("definePristine - pristine.js carregado");
          pristineScript.onerror = (e) =>
            logError("definePristine - falha ao carregar pristine.js", e);
          document.getElementsByTagName("head")[0].appendChild(pristineScript);
        }
      } catch (e) {
        logError("definePristine - falha injetando script:", e);
      }

      setTimeout(() => {
        try {
          if (typeof Pristine === "undefined") {
            logError(
              "definePristine - Pristine ainda undefined após 400ms; locale não configurado",
            );
            return;
          }
          Pristine.addMessages("pt-BR", {
            required: "Campo obrigatório",
            email: "Este campo requer um endereço de e-mail válido",
            number: "Este campo requer um número válido",
            integer: "Este campo requer um número inteiro válido",
            url: "Este campo requer uma URL válida",
            tel: "Este campo requer um número de telefone válido",
            maxlength: "Este campo deve ter no máximo ${1} caracteres",
            minlength: "Este campo deve ter pelo menos ${1} caracteres",
            min: "O campo deve ter pelo menos ${1} caracteres",
            max: "Este campo deve ter no máximo ${1} caracteres",
            pattern: "Este campo deve corresponder ao padrão",
            equals: "Os campos não correspondem",
            default: "Este campo não é válido",
          });
          Pristine.setLocale("pt-BR");
          logDebug("definePristine - locale pt-BR configurado");
        } catch (e) {
          logError("definePristine - falha configurando Pristine:", e);
        }
      }, 400);
    }

    function defineVMasker() {
      return new Promise((resolve) => {
        if (typeof VMasker !== "undefined") {
          resolve();
          return;
        }

        const script = document.createElement("script");
        script.src = "/assets/js/masker.js";
        script.type = "text/javascript";
        script.onload = () => resolve(); // Resolve a Promise quando o script carregar
        script.onerror = () => {
          console.error("Erro ao carregar o script masker.js");
          resolve(); // Pode optar por rejeitar a Promise, dependendo do caso
        };
        document.getElementsByTagName("head")[0].appendChild(script);
      });
    }

    function addStateChangeEvent(form) {
      try {
        const state = form.querySelector("[data-cf-type='state']");
        if (!state) {
          logDebug("addStateChangeEvent - sem campo data-cf-type=state");
          return;
        }
        logDebug("addStateChangeEvent - listener anexado");
        state.addEventListener("change", async (event) => {
          try {
            const selectedCity = form.querySelector("[data-cf-type='city']");
            if (!selectedCity) {
              return alert(
                "Não foi encontrado o campo do tipo cidade (city) no formulário.",
              );
            }
            if (selectedCity.options[0]) {
              selectedCity.options[0].text = "Carregando cidades...";
            }
            logDebug(
              "addStateChangeEvent - buscando cidades para",
              event.target.value,
            );
            const citiesRequest = await fetch(
              `https://api.cubosuite.com.br/tools/cities/country/BR/state/${event.target.value}`,
              { headers: { "Content-type": "application/json" } },
            );
            const cities = await citiesRequest.json();
            logDebug(
              "addStateChangeEvent - cidades recebidas:",
              cities && cities.length,
            );
            selectedCity.innerHTML = "";
            const emptyOption = document.createElement("option");
            emptyOption.value = "";
            emptyOption.text = "Selecione uma cidade";
            selectedCity.appendChild(emptyOption);
            (cities || []).forEach((c) => {
              const option = document.createElement("option");
              option.value = c.name;
              option.text = c.name;
              selectedCity.appendChild(option);
            });
          } catch (e) {
            logError("addStateChangeEvent - falha carregando cidades:", e);
          }
        });
      } catch (e) {
        logError("addStateChangeEvent - falha registrando listener:", e);
      }
    }

    function recoveryDealOnStorage() {
      try {
        const storage = localStorage.getItem("cuboDeal");
        return storage ? JSON.parse(storage) : null;
      } catch (e) {
        logError("recoveryDealOnStorage - falha:", e);
        return null;
      }
    }

    async function defineAllMasks(form) {
      await defineVMasker();
      if (typeof VMasker === "undefined") {
        logError("defineAllMasks - VMasker indefinido, máscaras puladas");
        return;
      }
      try {
        form
          .querySelectorAll("[mask]")
          .forEach((input) => {
            try {
              VMasker(input).maskPattern(input.getAttribute("mask"));
            } catch (e) {
              logError("defineAllMasks - falha aplicando máscara:", e);
            }
          });
        logDebug("defineAllMasks - máscaras aplicadas");
      } catch (e) {
        logError("defineAllMasks - falha:", e);
      }
    }

    function handleFormClick() {
      if (typeof dataLayer !== "undefined") {
        dataLayer.push({
          event: "formStart",
          eventModel: {
            form_id: this.getAttribute("id"),
            trigger_by: "CuboSuite",
          },
        });
      }
    }

    function shouldMakeConversion() {
      const url = new URL(window.location.href);
      const conversionParam = url.searchParams.get("conversion");
      const conversion = conversionParam
        ? conversionParam === "true"
          ? true
          : false
        : true;
      return conversion;
    }

    function containsBadWords(text) {
      const badWords = [
        "fodeu",
        "putinha",
        "vagabunda",
        "corno",
        "puta",
        "merda",
        "idiota",
        "imbecil",
        "burro",
        "corna",
        "kenga",
        "quenga",
        "cu",
        "buceta",
        "pinto",
        "penis",
        "bosta",
        "trouxa",
        "otário",
        "vagabundo",
        "bunda",
        "cuzão",
        "fedorento",
        "retardado",
        "estúpido",
        "feio",
        "ridículo",
        "desgraçado",
        "nojo",
        "nojento",
        "burra",
        "anta",
        "jumento",
        "falsa",
        "mentiroso",
        "maldoso",
        "miserável",
        "lixo",
        "meretriz",
        "idiotice",
        "imundo",
        "porco",
        "chifrudo",
        "infeliz",
        "asqueroso",
        "cretino",
        "maldito",
        "canalha",
        "imbecilidade",
        "vadio",
        "vagabundagem",
        "biscate",
        "pateta",
        "boçal",
        "babaca",
        "palhaço",
        "fuleiro",
        "desnecessário",
        "insignificante",
        "inútil",
        "incompetente",
        "débil",
        "deficiente",
        "grosseiro",
        "arrogante",
        "asno",
        "mala",
        "traste",
        "mané",
        "fracassado",
        "moleque",
        "preguiçoso",
        "mentecapto",
        "panaca",
        "insensato",
        "traidor",
        "enganador",
        "enganadora",
        "sem-vergonha",
        "injusto",
        "indecente",
        "imoral",
        "lento",
        "mole",
        "espertinho",
        "idiotinha",
        "porcaria",
        "patético",
        "mentira",
        "mentirosa",
        "peçonhento",
        "venenoso",
        "calhorda",
        "golpista",
        "safado",
        "canalha",
        "tolo",
        "ridículo",
        "bicho-do-mato",
        "estúpida",
        "idiotona",
        "tranqueira",
        "v@di@",
        "desclassificado",
        "trambiqueiro",
        "vagaba",
        "cabeça-de-vento",
        "tapado",
        "sem-futuro",
        "sem-educação",
        "bronco",
        "traste",
        "escória",
        "desumano",
        "irresponsável",
        "chato",
        "tosco",
        "cruel",
        "pilantra",
        "malandra",
        "baranga",
        "estrume",
        "otária",
        "trouxa",
        "bichona",
        "zé-ninguém",
        "vacilão",
        "fuleiro",
        "vergonhoso",
        "parasita",
        "encostado",
        "malcriado",
        "abusado",
        "desonesto",
        "cachorra",
        "mandrake",
        "pistoleira",
        "cretina",
        "abominável",
        "vaca",
        "galinha",
        "sem-honra",
        "mentirosinho",
        "idiotão",
        "mosca-morta",
        "chupim",
        "gentalha",
        "zé-ruela",
        "sem-caráter",
        "covarde",
        "marmota",
        "ralé",
        "baita",
        "abestado",
        "bobalhão",
        "chorão",
        "carniça",
        "torto",
        "perdedor",
        "amador",
        "trapaceiro",
        "falsiane",
        "invejoso",
        "ganancioso",
        "tarado",
        "patife",
        "maloqueiro",
        "vagabundinha",
        "carniça",
        "prostituta",
        "pé-rapado",
        "zé-povinho",
        "pervertido",
        "desgracinha",
        "baba-ovo",
        "falso",
        "trapaceira",
        "meleca",
        "insano",
        "desmiolado",
        "atrasado",
        "bicho-preguiça",
        "caradura",
        "piolho",
        "michê",
        "desocupado",
        "bobalhona",
        "doidinho",
        "esquisito",
        "incapaz",
        "patetão",
        "medíocre",
        "perua",
        "mala-sem-alça",
        "intrometido",
        "bagaceiro",
        "sem-palavra",
        "mentiroso",
        "fofoqueiro",
        "insuportável",
        "cínico",
        "impostor",
        "manipulador",
        "encrenqueiro",
        "folgado",
        "zé-droguinha",
        "analfabeto",
        "idiotice",
        "grotesco",
        "pestinha",
        "desmiolado",
        "inútil",
        "trapalhão",
        "enganadorzinho",
        "desalmado",
        "vexame",
        "enxerido",
        "viciado",
        "traiçoeiro",
        "fraudulento",
        "ordinário",
        "cara-de-pau",
        "lambão",
        "boca-suja",
        "mentirosão",
        "inexpressivo",
        "frustrado",
        "impotente",
        "sujo",
        "enrustido",
        "aloprado",
        "carniçento",
        "babacão",
        "mulambo",
        "abobado",
        "delinquente",
        "fracote",
        "zé-mané",
        "teimoso",
        "sem-vergonhinha",
        "trambiqueira",
        "tralha",
        "bandidinho",
        "corrupto",
        "vagabundão",
        "folgadão",
        "hipócrita",
        "estrupício",
        "macumbeiro",
        "ridícula",
        "fingido",
        "forasteiro",
        "descompensado",
        "doidaço",
        "bobinho",
        "talarico",
        "belzebu",
        "sarna",
        "desarranjado",
        "sem-sal",
        "sem-graça",
        "cabecinha",
        "bichinho",
        "fedorzão",
        "lambão",
        "papagaio",
        "trapaceirozinho",
        "jaguara",
        "bocó",
        "zé-treta",
        "macaco",
        "galinhona",
        "trapalhona",
        "vergonhosa",
        "descontrolado",
        "bagaceira",
        "molezinha",
        "farsante",
        "desprezível",
        "trombadinha",
        "caloteiro",
        "bandido",
        "sarnento",
        "exibido",
        "folgadinha",
        "marrento",
        "rato",
        "doido",
        "cabecudo",
        "michado",
        "espertalhão",
        "desesperado",
        "inconsequente",
      ];
      const formatted = text.toLowerCase();
      return badWords.some((word) => formatted.includes(word));
    }

    function setDealOnLocalStorage(dealCreated) {
      let attempts = 0;
      do {
        attempts++;
        try {
          localStorage.setItem("cuboDeal", JSON.stringify(dealCreated));
        } catch (exception) {
          logError("setDealOnLocalStorage - falha:", exception);
          break;
        }
        if (attempts >= 5) {
          logError("setDealOnLocalStorage - desisti após 5 tentativas");
          break;
        }
      } while (localStorage.getItem("cuboDeal") == null);
      logDebug("setDealOnLocalStorage - concluído em", attempts, "tentativa(s)");
    }

    async function sendToCubo(type, payload, deal) {
      const url =
        type === "create"
          ? `https://api.cubosuite.com.br/deals/external`
          : `https://api.cubosuite.com.br/deals/external/${deal && deal.id}`;
      const method = type === "create" ? "POST" : "PUT";
      const t0 =
        typeof performance !== "undefined" ? performance.now() : Date.now();
      logDebug("sendToCubo - request", { method, url });
      try {
        const dealResponse = await fetch(url, {
          method,
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${props.keycubo}`,
          },
          body: JSON.stringify(payload),
        });
        const t1 =
          typeof performance !== "undefined" ? performance.now() : Date.now();
        logDebug("sendToCubo - response", {
          status: dealResponse.status,
          ok: dealResponse.ok,
          ms: Math.round(t1 - t0),
        });
        return await dealResponse.json();
      } catch (e) {
        logError("sendToCubo - fetch falhou:", e);
        throw e;
      }
    }

    async function sendFacebookCreate(deal) {
      const sendEventFunction =
        typeof window.sendEvent === "function" ? window.sendEvent : undefined;
      const getFacebookDataFunction =
        typeof window.getFacebookData === "function"
          ? window.getFacebookData
          : undefined;
      const enhanceDataFunction =
        typeof window.enhanceData === "function"
          ? window.enhanceData
          : undefined;
      const conversionEventName =
        typeof facebookConversionEvent !== "undefined"
          ? facebookConversionEvent
          : "Lead";

      if (
        !sendEventFunction ||
        !getFacebookDataFunction ||
        !enhanceDataFunction
      )
        return "Não foi possivel enviar dados para o facebook, verifique o adblock";

      const emailField = deal.customfields.find(
        (field) =>
          field.customfield.name.toLowerCase() === "email" ||
          field.customfield.name.toLowerCase() === "e-mail",
      );

      const peopleName = (deal.people && deal.people.name) ? String(deal.people.name).trim() : "";
      const nameParts = peopleName ? peopleName.split(/\s+/).filter(Boolean) : [];

      const userData = {
        email: emailField ? emailField.value : "",
        phone: deal.people.phone ? deal.people.phone : "",
        firstName: nameParts[0] || "",
        lastName: nameParts.length > 1 ? nameParts.slice(1).join(" ") : "",
        external_id: deal.people && deal.people.id ? String(deal.people.id) : undefined,
      };
      const fbData = await getFacebookData();
      const enhancedDataCookie = Cookies.get("enhancedData");
      const enhancedData = enhancedDataCookie
        ? JSON.parse(enhancedDataCookie)
        : await enhanceDataFunction().catch(() => ({}));

      const eventId = (typeof crypto !== "undefined" && crypto.randomUUID)
        ? crypto.randomUUID()
        : `submit-${Date.now()}-${Math.random().toString(36).slice(2)}`;

      if (typeof window.fbq === "function") {
        window.fbq("track", conversionEventName, {}, { eventID: eventId });
      }

      await sendEvent(conversionEventName, {
        ...fbData,
        ...enhancedData,
        ...userData,
      }, eventId);

      return "Enviado com sucesso";
    }

    async function sendFacebookUpdate() {
      const sendEventFunction =
        typeof window.sendEvent === "function" ? window.sendEvent : undefined;
      const getFacebookDataFunction =
        typeof window.getFacebookData === "function"
          ? window.getFacebookData
          : undefined;
      const enhanceDataFunction =
        typeof window.enhanceData === "function"
          ? window.enhanceData
          : undefined;

      if (
        !sendEventFunction ||
        !getFacebookDataFunction ||
        !enhanceDataFunction
      )
        return "Não foi possivel enviar dados para o facebook, verifique o adblock";

      const fbData = await getFacebookData();
      const enhancedDataCookie = Cookies.get("enhancedData");
      const enhancedData = enhancedDataCookie
        ? JSON.parse(enhancedDataCookie)
        : await enhanceDataFunction().catch(() => ({}));

      const eventId = (typeof crypto !== "undefined" && crypto.randomUUID)
        ? crypto.randomUUID()
        : `lead-q-${Date.now()}-${Math.random().toString(36).slice(2)}`;

      if (typeof window.fbq === "function") {
        window.fbq("track", "Lead_qualificado", {}, { eventID: eventId });
      }

      await sendEvent("Lead_qualificado", {
        ...fbData,
        ...enhancedData,
      }, eventId);

      return "Enviado com sucesso";
    }

    function getGoogleTrackingData() {
      const urlParams = new URLSearchParams(window.location.search);
      const data = {};

      const gclid = urlParams.get("gclid");
      const gbraid = urlParams.get("gbraid");
      const wbraid = urlParams.get("wbraid");

      if (gclid) data.gclid = gclid;
      if (gbraid) data.gbraid = gbraid;
      if (wbraid) data.wbraid = wbraid;

      if (typeof Cookies !== "undefined") {
        const gaRaw = Cookies.get("_ga");
        if (gaRaw) {
          const gaParts = gaRaw.split(".");
          if (gaParts.length >= 4) data.gaClientId = gaParts.slice(2).join(".");
        }
      }

      return data;
    }

    function fillUrlParams(form) {
      const urlParams = new URLSearchParams(window.location.search);

      const utmMappings = {
        utm_source: ["utm_source", "Origem do Lead"],
        utm_medium: ["utm_medium", "Nome da Campanha"],
        utm_campaign: ["utm_campaign", "Público da Campanha"],
        utm_id: ["utm_id"],
        utm_term: ["utm_term", "Termo da Campanha"],
        utm_content: ["utm_content", "Anúncio da Campanha"],
      };

      form.querySelectorAll("input, select").forEach((field) => {
        const dataCf = field.getAttribute("data-cf");
        const normalizedDataCf = dataCf?.toLowerCase().split(" ").join("_");

        if (normalizedDataCf && urlParams.has(normalizedDataCf)) {
          field.value = urlParams.get(normalizedDataCf);
        }

        Object.keys(utmMappings).forEach((utmKey) => {
          if (urlParams.has(utmKey)) {
            const utmValue = urlParams.get(utmKey);
            const possibleFieldNames = utmMappings[utmKey];
            const normalizedPossibleNames = possibleFieldNames.map((n) =>
              n.toLowerCase().split(" ").join("_"),
            );

            if (
              normalizedDataCf === utmKey ||
              (normalizedDataCf &&
                normalizedPossibleNames.includes(normalizedDataCf))
            ) {
              field.value = utmValue;
            }
          }
        });
      });
    }

    async function handleSubmit(event) {
      let button = null;
      let oldText = null;
      try {
        event.preventDefault();

        safeRun("fillUrlParams", () => fillUrlParams(event.target));
        logDebug("[1] form-submit - Iniciando submit", {
          action: props.action,
          pipe: props.pipeId,
          key: props.keycubo ? "***" : "(vazio)",
          event,
        });

        const needToMakeConversions = shouldMakeConversion();
        logDebug("[2] form-submit - vai ter conversões", {
          needToMakeConversions,
        });

        const deal = recoveryDealOnStorage();
        button = event.target.querySelector("button[type='submit']");
        oldText = button ? button.innerText : null;
        logDebug("[2] form-submit - Localstorage e botão", { deal, button });

        if (!button) {
          logError("[2.1] form-submit - botão submit não encontrado, abortando");
          return;
        }

        if (props.action === "create") {
          try {
            localStorage.removeItem("cuboDeal");
          } catch (e) {
            logError("[2.2] form-submit - falha removendo cuboDeal:", e);
          }
        }

        button.setAttribute("disabled", true);
        logDebug("[3] form-submit - botão desativado", { deal, button });
        button.innerText = "Enviando...";

        if (deal && !deal.id && props.action === "update") {
          logDebug("[3.1] form-submit - Id da negociação não informada");
          alert("Id da negociação não informada");
          restoreButton(button, oldText);
          return;
        }

        if (!props.pipe && props.action === "create") {
          logDebug("[3.2] form-submit - Funil não informado");
          alert("Funil não informado");
          restoreButton(button, oldText);
          return;
        }

        if (!props.keycubo) {
          logDebug("[3.3] form-submit - API KEY não informada");
          alert("API KEY não informada");
          restoreButton(button, oldText);
          return;
        }

        const form = event.target;
        logDebug("[3.4] form-submit - Formulário válido", { form });

        if (typeof Pristine === "undefined") {
          logError(
            "[4.0] form-submit - Pristine indefinido, pulando validação cliente",
          );
        }

        let valid = true;
        let pristine = null;
        if (typeof Pristine !== "undefined") {
          try {
            pristine = new Pristine(event.target, {
              classTo: "cubo-form-group",
              errorTextParent: "cubo-form-group",
            });
            valid = pristine.validate();
          } catch (e) {
            logError(
              "[4.0.1] form-submit - Pristine instanciar/validate falhou, ignorando:",
              e,
            );
            valid = true;
          }
        }
        logDebug("[4] form-submit - Validando campos", { pristine, valid });

        if (!valid) {
          logDebug("[4.1] form-submit - Campos inválidos, reativando o botão", {
            pristine,
            valid,
          });
          if (pristine && typeof pristine.getErrors === "function") {
            try {
              logDebug("[4.1.1] pristine.getErrors():", pristine.getErrors());
            } catch (e) {}
          }
          restoreButton(button, oldText);
          return;
        }

        const hasBadWords =
          props.filter_bad_words === "yes"
            ? safeRun("containsBadWords", () =>
                containsBadWords(
                  form.querySelector("[name='title']")
                    ? form.querySelector("[name='title']").value
                    : "Não informado",
                ),
              ) === true
            : false;

        if (hasBadWords) {
          logDebug("[4.2] form-submit - Palavras proibidas detectadas", {
            hasBadWords,
          });
          button.innerText = "Obrigado pelo contato!";
          return;
        }

        logDebug("[5] form-submit - Formulário válido", { pristine, valid });

        const fields = form.querySelectorAll("input, select");

        const payload =
          props.action === "update"
            ? { customfields: [] }
            : {
                title: form.querySelector("[name='title']")
                  ? form.querySelector("[name='title']").value
                  : "Não informado",
                peopleName: form.querySelector("[name='title']")
                  ? form.querySelector("[name='title']").value
                  : "Não informado",
                peoplePhone: form.querySelector("[name='phone']")
                  ? form.querySelector("[name='phone']").value
                  : "Não informado",
                customfields: [],
              };

        logDebug("[6] form-submit - Payload base montado", { payload });

        if (props.action === "create") payload.pipeId = props.pipe;
        if (props.action === "create") payload.stageId = props.stage;

        if (typeof Cookies !== "undefined") {
          try {
            payload.fbc = Cookies.get("_fbc") || null;
            payload.fbp = Cookies.get("_fbp") || null;
          } catch (e) {
            logError("[6.0] form-submit - Cookies.get falhou:", e);
          }
        } else {
          logError(
            "[6.0] form-submit - Cookies indefinido (adblock?), pulando fbc/fbp",
          );
        }

        const googleData =
          safeRun("getGoogleTrackingData", () => getGoogleTrackingData()) || {};
        Object.assign(payload, googleData);

        const landingId = safeRun("landingId", () =>
          Number(document.body.getAttribute("lid")),
        );
        if (landingId) payload.landingId = landingId;

        logDebug(
          "[6.1] form-submit - Facebook (fbc/fbp) + Google (gclid/gbraid/wbraid/gaClientId) + landingId",
          { fbc: payload.fbc, fbp: payload.fbp, ...googleData, landingId },
        );

        logDebug(
          "[7] form-submit - Iniciando recuperação de campos personalizados",
          { fieldCount: fields && fields.length },
        );

        fields.forEach((field, idx) => {
          try {
            const type = field.getAttribute("type")
              ? field.getAttribute("type")
              : "text";
            const nameAttribute = field.getAttribute("name");
            const customfieldName = field.getAttribute("data-cf");

            logDebug(`[7.${idx}] field`, {
              type,
              nameAttribute,
              customfieldName,
              value: field.value,
            });

            if (nameAttribute !== "title" && nameAttribute !== "phone") {
              const isSelect =
                type === "select" || (field.tagName || "").toUpperCase() === "SELECT";
              if (isSelect) {
                const selectedOpt =
                  field.options && field.selectedIndex >= 0
                    ? field.options[field.selectedIndex]
                    : null;
                if (selectedOpt && selectedOpt.value) {
                  payload.customfields.push({
                    customfieldId: parseInt(field.getAttribute("name")),
                    value: selectedOpt.value,
                  });
                }
              } else {
                const name = customfieldName
                  ? customfieldName.toLowerCase().split(" ").join("_")
                  : nameAttribute;
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);

                if (!field.value)
                  field.value = urlParams.has(name) ? urlParams.get(name) : null;

                if (field.value) {
                  payload.customfields.push({
                    customfieldId: parseInt(field.getAttribute("name")),
                    value: field.value,
                  });
                }
              }
            }
          } catch (e) {
            logError(`[7.${idx}] form-submit - falha processando field:`, e);
          }
        });

        payload.customfields = payload.customfields.filter((cf) => cf.value);

        logDebug(
          "[8] form-submit - Campos personalizados recuperados, enviando para o cubo",
          { payload },
        );

        const storageDeal = recoveryDealOnStorage();
        logDebug("[8.1] form-submit - Lead guardado no storage", { storageDeal });

        let dealCreated;
        try {
          dealCreated = await sendToCubo(props.action, payload, storageDeal);
        } catch (e) {
          logError("[8.2] form-submit - sendToCubo falhou:", e);
          alert(
            "Falha ao enviar formulário. Verifique sua conexão e tente novamente.",
          );
          restoreButton(button, oldText);
          return;
        }

        logDebug("[9] form-submit - Resposta do API", { dealCreated });

        if (props.action === "create") {
          logDebug("[9.1] form-submit - Inserindo cuboDeal do LocalStorage");
          safeRun("setDealOnLocalStorage", () =>
            setDealOnLocalStorage(dealCreated),
          );
          logDebug("[9.2] form-submit - CuboDeal inserido no LocalStorage");
        }

        logDebug(
          "[10] form-submit - Preparando para enviar para o Datalayer",
          typeof dataLayer,
        );

        if (typeof dataLayer !== "undefined" && needToMakeConversions) {
          logDebug(
            "[10.1] form-submit - Datalayer definido, enviando evento para o GTM",
          );
          safeRun("dataLayer.push", () => {
            dataLayer.push({
              event: "formSubmit",
              eventModel: {
                form_id: event.target.getAttribute("id"),
                trigger_by: "CuboSuite",
                user_name: payload.title,
                user_phone: payload.peoplePhone,
                user_email:
                  form.querySelector('[data-cf="E-mail"]') !== null
                    ? form.querySelector('[data-cf="E-mail"]').value
                    : form.querySelector('[data-cf="Email"]') !== null
                      ? form.querySelector('[data-cf="Email"]').value
                      : "Não informado",
              },
            });
          });
        }

        if (needToMakeConversions) {
          const facebookConversion = await safeRunAsync("facebookConversion", () =>
            props.action === "create"
              ? sendFacebookCreate(dealCreated)
              : sendFacebookUpdate(),
          );
          logDebug(
            "[10.2] form-submit - Tentativa de envio para o facebook -> ",
            facebookConversion,
          );
        }

        logDebug("[11] form-submit - Preparando para enviar para o VWO");

        if (needToMakeConversions) {
          safeRun("VWO", () => {
            window.VWO = window.VWO || [];
            VWO.event =
              VWO.event ||
              function () {
                VWO.push(["event"].concat([].slice.call(arguments)));
              };
            VWO.event("lead_prospecta", { lead_prospecta: true });
          });
          logDebug(
            "[12] form-submit - VWO enviado. Redirecionamento:",
            props.redirect,
          );
        }

        if (props.redirect) {
          logDebug("[13] form-submit - Redirecionando para", props.redirect);
          button.innerText = "Redirecionando...";
          window.location.href = props.redirect;
          return;
        }

        button.removeAttribute("disabled");
        button.innerText = "Enviado";
        logDebug("handleSubmit - FIM com sucesso");
      } catch (e) {
        logError("handleSubmit - exceção não tratada:", e);
        try {
          if (button) {
            button.removeAttribute("disabled");
            button.innerText = oldText || "Tente novamente";
          }
        } catch (e2) {}
      }
    }

    safeRun("bootstrap.hideFields", () => hideFields());
    safeRun("bootstrap.defineCookies", () => defineCookies());
    safeRun("bootstrap.definePristine", () => definePristine());
    safeRun("bootstrap.defineVMasker", () => defineVMasker());
    safeRun("bootstrap.addStateChangeEvent", () => addStateChangeEvent(this));

    if (props.action === "update") {
      setTimeout(() => {
        try {
          const deal = recoveryDealOnStorage();
          const url = window.location.href;

          if (
            (!deal || !deal.id) &&
            !url.includes("127.0.0.1") &&
            !url.includes("builder.cubosuite.com.br") &&
            !url.includes("localhost")
          ) {
            alert("É necessario preencher a primeira etapa");
            if (props.redirect_not_filed) {
              window.location.href = props.redirect_not_filed;
              return;
            }
            return;
          }

          const fields = this.querySelectorAll("input, select");

          if (this.querySelector('[name="title"]')) {
            this.querySelector('[name="title"]').value =
              deal && deal.people && deal.people.name ? deal.people.name : "";
          }
          if (this.querySelector('[name="phone"]')) {
            this.querySelector('[name="phone"]').value =
              deal && deal.people && deal.people.phone
                ? deal.people.phone
                : "";
          }

          fields.forEach((field) => {
            try {
              const type = field.getAttribute("type");
              const id = field.getAttribute("name");
              const customfieldName = field.getAttribute("data-cf");
              const customfield =
                deal && deal.customfields && deal.customfields.length > 0
                  ? deal.customfields.find(
                      (customfield) => customfield.customfield.id === id,
                    )
                  : null;

              if (
                customfieldName !== "phone" &&
                customfieldName !== "title" &&
                customfield
              ) {
                if (type === "text" || type === "email") {
                  field.value = customfield.value;
                }
                if (type === "select") {
                  field.value = customfield.value;
                }
              }
            } catch (e) {
              logError("update.hydrate field falhou:", e);
            }
          });

          if (typeof VMasker !== "undefined") {
            this.querySelectorAll("[mask]").forEach((input) => {
              try {
                VMasker(input).maskPattern(input.getAttribute("mask"));
              } catch (e) {
                logError("update.mask aplicação falhou:", e);
              }
            });
          } else {
            logError(
              "update.300ms - VMasker indefinido, máscaras não aplicadas (vão ser aplicadas em 500ms)",
            );
          }
        } catch (e) {
          logError("update.setTimeout(300) falhou:", e);
        }
      }, 300);
    }

    setTimeout(async () => {
      try {
        definePristine();
        await defineAllMasks(this);
      } catch (e) {
        logError("bootstrap.setTimeout(500) falhou:", e);
      }
    }, 500);

    const needToMakeConversions = shouldMakeConversion();
    if (needToMakeConversions) {
      this.addEventListener(
        "click",
        function () {
          try {
            handleFormClick.call(this);
          } catch (e) {
            logError("handleFormClick falhou:", e);
          }
        },
        { once: true },
      );
    }

    this.addEventListener("submit", (event) => handleSubmit(event));
    logDebug("BOOT - submit listener anexado, formulário pronto");
  };

  const component = {
    isComponent(el) {
      if (
        el?.tagName === "form" &&
        (el.getAttribute("componentName") === "formNew" ||
          el.getAttribute("componentName") === "formNew")
      ) {
        return { type: "formNew" };
      }
    },

    model: {
      defaults: {
        tagName: "form",
        attributes: { method: "POST", componentName: "formNew" },
        droppable: false,
        traits: [
          {
            label: "Formulário",
            type: "select",
            name: "form",
            changeProp: true,
            options: [{ name: "Selecione um formulário", id: "" }, ...forms],
            required: true,
          },
          {
            label: "Ação",
            type: "select",
            name: "action",
            changeProp: true,
            options: [
              { name: "Criação", id: "create" },
              { name: "Atualização", id: "update" },
            ],
            required: true,
            value: "create",
          },
          {
            label: "Api key",
            type: "text",
            name: "keycubo",
            changeProp: true,
            required: true,
          },
          {
            label: "Funíl",
            type: "select",
            name: "pipe",
            changeProp: true,
            options: pipes,
            required: true,
          },
          {
            label: "Estágio",
            type: "select",
            name: "stage",
            changeProp: true,
            options: [{ name: "Selecione o funil", id: "" }],
            required: true,
          },
          {
            label: "Redirecionar para",
            type: "text",
            name: "redirect",
            changeProp: true,
          },
          {
            label: "Redirecionar se não prencheu primeira etapa",
            type: "text",
            name: "redirect_not_filed",
            changeProp: true,
          },
          {
            label: "Filtrar palavrões",
            type: "select",
            name: "filter_bad_words",
            options: [
              { name: "Sim", id: "yes" },
              { name: "Não", id: "no" },
            ],
            changeProp: true,
            value: "yes",
          },
        ],
        classes: ["cubo-form", "rows", "wrap"],

        styles: `
          .column {
            display: flex;
            flex-direction: column;
          }

          .rows {
              display: flex;
          }

          .wrap {
              flex-wrap: wrap;
          }

          .column-1 {
              max-width: 8.33%;
              flex: 0 0 8.333333%;
          }

          .column-2 {
              max-width: 16.66%;
              flex: 0 0 16.66%;
          }

          .column-3 {
              max-width: 25%;
              flex: 0 0 25%;
          }

          .column-4 {
              max-width: 33.33%;
              flex: 0 0 33.33%;
          }

          .column-5 {
              max-width: 41.66%;
              flex: 0 0 41.66%;
          }

          .column-6 {
              max-width: 50%;
              flex: 0 0 50%;
          }

          .column-7 {
              max-width: 58.47%;
              flex: 0 0 58.47%;
          }

          .column-8 {
              max-width: 66.66%;
              flex: 0 0 66.66%;
          }

          .column-9 {
              max-width: 75.18%;
              flex: 0 0 75.18%;
          }

          .column-10 {
              max-width: 83.33%;
              flex: 0 0 83.33%;
          }

          .column-11 {
              max-width: 91.74%;
              flex: 0 0 91.74%;
          }

          .column-12 {
              max-width: 100%;
              flex: 0 0 100%;
          }

          @media screen and (min-width: 1200px) {
              .column-lg-1 {
                  max-width: 8.33%;
                  flex: 0 0 8.333333%;
              }

              .column-lg-2 {
                  max-width: 16.66%;
                  flex: 0 0 16.66%;
              }

              .column-lg-3 {
                  max-width: 25%;
                  flex: 0 0 25%;
              }

              .column-lg-4 {
                  max-width: 33.33%;
                  flex: 0 0 33.33%;
              }

              .column-lg-5 {
                  max-width: 41.66%;
                  flex: 0 0 41.66%;
              }

              .column-lg-6 {
                  max-width: 50%;
                  flex: 0 0 50%;
              }

              .column-lg-7 {
                  max-width: 58.47%;
                  flex: 0 0 58.47%;
              }

              .column-lg-8 {
                  max-width: 66.66%;
                  flex: 0 0 66.66%;
              }

              .column-lg-9 {
                  max-width: 75.18%;
                  flex: 0 0 75.18%;
              }

              .column-lg-10 {
                  max-width: 83.33%;
                  flex: 0 0 83.33%;
              }

              .column-lg-11 {
                  max-width: 91.74%;
                  flex: 0 0 91.74%;
              }

              .column-lg-12 {
                  max-width: 100%;
                  flex: 0 0 100%;
              }
          }

          @media screen and (min-width: 1200px) and (max-width:2000px) {
              .column-md-1 {
                  max-width: 8.33%;
                  flex: 0 0 8.333333%;
              }

              .column-md-2 {
                  max-width: 16.66%;
                  flex: 0 0 16.66%;
              }

              .column-md-3 {
                  max-width: 25%;
                  flex: 0 0 25%;
              }

              .column-md-4 {
                  max-width: 33.33%;
                  flex: 0 0 33.33%;
              }

              .column-md-5 {
                  max-width: 41.66%;
                  flex: 0 0 41.66%;
              }

              .column-md-6 {
                  max-width: 50%;
                  flex: 0 0 50%;
              }

              .column-md-7 {
                  max-width: 58.47%;
                  flex: 0 0 58.47%;
              }

              .column-md-8 {
                  max-width: 66.66%;
                  flex: 0 0 66.66%;
              }

              .column-md-9 {
                  max-width: 75.18%;
                  flex: 0 0 75.18%;
              }

              .column-md-10 {
                  max-width: 83.33%;
                  flex: 0 0 83.33%;
              }

              .column-md-11 {
                  max-width: 91.74%;
                  flex: 0 0 91.74%;
              }

              .column-md-12 {
                  max-width: 100%;
                  flex: 0 0 100%;
              }
          }

          @media screen and (max-width:576px) {
              .column-sm-1 {
                  max-width: 8.33%;
                  flex: 0 0 8.333333%;
              }

              .column-sm-2 {
                  max-width: 16.66%;
                  flex: 0 0 16.66%;
              }

              .column-sm-3 {
                  max-width: 25%;
                  flex: 0 0 25%;
              }

              .column-sm-4 {
                  max-width: 33.33%;
                  flex: 0 0 33.33%;
              }

              .column-sm-5 {
                  max-width: 41.66%;
                  flex: 0 0 41.66%;
              }

              .column-sm-6 {
                  max-width: 50%;
                  flex: 0 0 50%;
              }

              .column-sm-7 {
                  max-width: 58.47%;
                  flex: 0 0 58.47%;
              }

              .column-sm-8 {
                  max-width: 66.66%;
                  flex: 0 0 66.66%;
              }

              .column-sm-9 {
                  max-width: 75.18%;
                  flex: 0 0 75.18%;
              }

              .column-sm-10 {
                  max-width: 83.33%;
                  flex: 0 0 83.33%;
              }

              .column-sm-11 {
                  max-width: 91.74%;
                  flex: 0 0 91.74%;
              }

              .column-sm-12 {
                  max-width: 100%;
                  flex: 0 0 100%;
              }
          }

          .cubo-form{
            padding: 10px;
            font-family: Nunito,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;
          }

          .cubo-form input{
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
            background: #fff;
            border: 1px solid #e2e4e6cc;
            border-radius: 3px;
            color: #5c6268;
            font-size: .875rem;
            padding: 0.5rem;
            width: 100%;
            transition: background-color .2s,color .2s,border-color .2s,box-shadow .2s;
          }

          .cubo-form select{
            appearance: none;
            padding: 8px;
            width: 100%;
            cursor: pointer;
            background: #fff;
            color: #5c6268;
            border: 1px solid #ced4da;
            border-radius: 3px;
            transition: background-color .2s,color .2s,border-color .2s,box-shadow .2s;
          }

          .cubo-form select::after{
            content: '';
            position: absolute;
            top: 50%;
            right: 10px;
            transform: translateY(-50%);
            width: 0;
            height: 0;
            border-left: 5px solid transparent;
            border-right: 5px solid transparent;
            border-top: 5px solid #333; /* Arrow color */
            pointer-events: none;
          }

          .cubo-form button{
            color: #ffffff;
            background: #64748B;
            border: 1px solid #64748B;
            padding: 0.5rem 1rem;
            font-size: 1rem;
            transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
            border-radius: 3px;
          }

          .cubo-form button::hover{
            background: #334155;
            color: #ffffff;
            border-color: #334155;
          }

          .has-danger .pristine-error.text-help{
            color: red;
            padding: 5px;
            margin: 5px;
            background-color: #ffdede;
            border-radius: 5px;
            width: fit-content;
          }

          .form-group.has-danger input, .form-group.has-danger select{
            border-color: red!important;
          }

          .swal2-shown.swal2-height-auto{
            height: 100vh!important;
          }
        `,

        pipe: "",
        stage: "",
        keycubo: "",
        redirect: "",
        form: "",
        action: "create",
        form: "",
        redirect_not_filed: "",
        filter_bad_words: "yes",

        script,

        "script-props": [
          "pipe",
          "keycubo",
          "redirect",
          "form",
          "stage",
          "action",
          "redirect_not_filed",
          "filter_bad_words",
        ],

        components: (model) => {
          return {
            tagName: "div",
            layerable: false,
            locked: true,
            attributes: {
              style:
                "display: flex; padding: 10px; align-items: center; width: 100%; justify-content: center;",
            },
            components: [
              {
                locked: true,
                layerable: false,
                tagName: "strong",
                content:
                  "Use o menu de configurações para configurar o formulário",
                attributes: {
                  style: "margin-left: 10px;",
                },
              },
              {
                locked: true,
                layerable: false,
                tagName: "span",
                content: "➡️",
                attributes: {
                  style: "font-size: 30px; margin-left: 10px",
                },
              },
            ],
          };
        },
      },
      init() {
        editor.on("component:selected", (addedComponent) => {
          if (addedComponent === this) {
          }
        });

        editor.on("component:add", (addedComponent) => {
          if (addedComponent === this) {
            editor.stopCommand("core:component-outline");
            editor.select(this);
            if (document.querySelector('[title="Settings"]') !== null) {
              document.querySelector('[title="Settings"]').click();
            }
          }
        });

        editor.on("component:update:traits", (component) => {
          if (component.get("type") === "formNew") {
            const traits = component.get("traits");

            const pipeTrait = traits.find(
              (trait) => trait.get("name") === "pipe",
            );
            const stageTrait = traits.find(
              (trait) => trait.get("name") === "stage",
            );

            if (pipeTrait && stageTrait) {
              const pipeValue = pipeTrait.get("value");
              const selectedPipe = pipes.find(
                (pipe) => pipe.id === +pipeValue,
              ) || { stages: [] };
              stageTrait.set(
                "options",
                selectedPipe.stages.map((s) => {
                  return { name: s.name, id: s.id };
                }),
              );
            }
          }
        });

        this.on("change:form", (event) => {
          const form = forms.find((form) => form.id === +event.changed.form);
          const components = [];

          form.fields.forEach((field) => {
            const item = {
              tagName: "div",
              type: "cuboFormRow",
              classes: [
                "cubo-form-group",
                "column-sm-12",
                `column-${field.columns ? field.columns : 12}`,
              ],
              attributes: {
                columns: field.columns,
                style: field.hide ? "display:none;" : null,
                "data-hidden": field.hide ? "true" : "false",
              },
              components: [
                {
                  content: `${field.label}`,
                  tagName: "label",
                  components:
                    field.required || field.validations.required
                      ? [
                          {
                            tagName: "span",
                            content: `${field.label}`,
                          },
                          {
                            tagName: "strong",
                            content: "*",
                            attributes: {
                              style: "color:red;margin-left: 5px;",
                            },
                          },
                        ]
                      : null,
                },
              ],
            };

            if (
              field.id === "phone" ||
              field.id === "title" ||
              (field.isCustomfield && field.customfield.type === "text")
            ) {
              item.components.push({
                tagName: "input",
                attributes: {
                  class: "form-control",
                  type: field.validations.type.value
                    ? field.validations.type.value
                    : "text",
                  placeholder: field.placeholder
                    ? field.placeholder
                    : "Preencha o campo",
                  name: field.id,
                  "data-cf": field.isCustomfield ? field.customfield.name : "",
                  "data-cf-type": field.isCustomfield
                    ? field.customfield.type
                    : "",
                  mask: field.id === "phone" ? "(99) 99999-9999" : null,
                  "data-pristine-required":
                    field.required || field.validations.required ? "" : null,
                  "data-pristine-max": field.validation?.maxLength?.use
                    ? field.validation.maxLength.use
                    : field.validation?.maxLenght?.use
                      ? field.validation.maxLenght.use
                      : null,
                  "data-pristine-min": field.validation?.minLength?.use
                    ? field.validation.minLength.use
                    : field.validation?.minLenght?.use
                      ? field.validation.minLenght.use
                      : null,
                },
              });
            } else {
              const select = {
                tagName: "select",
                attributes: {
                  name: field.id,
                  "data-cf": field.customfield.name,
                  "data-pristine-required":
                    field.required || field.validations.required ? "" : null,
                  "data-pristine-max": field.validation?.maxLength?.use
                    ? field.validation.maxLength.use
                    : field.validation?.maxLenght?.use
                      ? field.validation.maxLenght.use
                      : null,
                  "data-pristine-min": field.validation?.minLength?.use
                    ? field.validation.minLength.use
                    : field.validation?.minLenght?.use
                      ? field.validation.minLenght.use
                      : null,
                  "data-cf-type": field.customfield.type,
                },
                components: [
                  {
                    tagName: "option",
                    attributes: {
                      selected: true,
                      disabled: true,
                      value: "",
                    },
                    content: field.placeholder
                      ? field.placeholder
                      : "Selecione uma opção",
                  },
                ],
              };

              if (
                field.customfield.type === "state" ||
                field.customfield.type === "city"
              ) {
                const options =
                  field.customfield.type === "state"
                    ? State.getStatesOfCountry("BR")
                    : [];
                options.forEach((opt) => {
                  select.components.push({
                    tagName: "option",
                    attributes: {
                      value: opt.isoCode,
                    },
                    content: opt.name,
                  });
                });
              } else {
                field.customfield.options.forEach((opt) => {
                  select.components.push({
                    tagName: "option",
                    attributes: {
                      value: opt.value,
                    },
                    content: opt.value,
                  });
                });
              }

              item.components.push(select);
            }
            components.push(item);
            return;
          });

          components.push({
            tagName: "div",
            type: "cuboFormRow",
            classes: ["cubo-form-group", "column-sm-12", `column-2`],
            components: [
              {
                tagName: "button",
                type: "cubosuiteButton",
                attributes: {
                  type: "submit",
                },
              },
            ],
          });

          this.components(components);
        });
      },
    },

    view: {},
  };

  return component;
};
